const ContinuedText = ({ text = '', size = 100 }) => {
    const content = (text || '').length > size
        ? `${text.substring(0, size)}&#8230;`
        : text
    return <span dangerouslySetInnerHTML={{__html: content }} />
}

export default ContinuedText